'use client';
module.exports = require('../dist/components/Divider/Divider');
